import React from 'react';
import PropTypes from 'prop-types';

import SelectFilter from 'components/search_sidebar/select_filter';
import { getPortaledMenuProps } from 'helpers/react_select_helpers';

export function OfficeFilter({ classNamePrefix, office, officeOptions, onChange }) {
  if (!officeOptions.length) return null;

  return (
    <SelectFilter
      {...getPortaledMenuProps()}
      classNamePrefix={classNamePrefix}
      options={officeOptions}
      value={office || officeOptions[0]}
      onChange={onChange}
    />
  );
}

OfficeFilter.propTypes = {
  classNamePrefix: PropTypes.string,
  office: PropTypes.object,
  officeOptions: PropTypes.array,
  onChange: PropTypes.func
};


export default OfficeFilter;